import { ContextMenuButton, Td, Tr } from 'app/components/Table';
import { MouseEvent } from 'react';
import { ListItemText } from 'app/components/ChakraTableList';
import { useAppDispatch, useAppSelector } from 'app/store';
import { ListItemAction } from 'app/components/ChakraTableList/ListItemAction';
import { SongCoverActionButton } from 'app/components/Song/SongCoverActionButton';
import { Song, SongStatusLabel } from 'types/song';
import { SongCover } from 'app/components/Song/SongCover';
import { routes } from 'app/routing/routesConfig';
import { useNavigate } from 'react-router-dom';
import {
  getIsPlayerLoading,
  getPlayerCurrentAudio,
} from 'app/store/AudioPlayer/selectors';
import { clearResultsAction } from 'app/store/GlobalSearch/slice';

interface SongResultsRowProps {
  song: Song;
  audioGuid?: string;
  isPlaying: boolean;
  handlePlay: (song: Song) => void;
  contextHandler?: (e: MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
}

export const SongResultsRow = ({
  song,
  isPlaying,
  handlePlay,
  contextHandler,
}: SongResultsRowProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentAudio = useAppSelector(getPlayerCurrentAudio);
  const isPlayerLoading = useAppSelector(getIsPlayerLoading);

  const isSongLoaded =
    Boolean(currentAudio) && currentAudio.audioGuid === song.latestVersionAudio;
  const isSongPlaying = isPlaying && isSongLoaded;
  const shouldShowPlay =
    song._links?.playLatestVersion && song.latestVersionAudio;

  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      onContextMenu={contextHandler}
      clickable
      onClick={() => {
        dispatch(clearResultsAction());
        navigate(routes.song.path.replace(':guid', song.guid));
      }}
    >
      <Td isAvatar sx={{ overflow: 'visible' }}>
        {shouldShowPlay ? (
          <ListItemAction onClick={() => handlePlay(song)}>
            <SongCoverActionButton
              isSongPlaying={isSongPlaying}
              status={song.status}
              isLoading={isSongLoaded && isPlayerLoading}
            />
          </ListItemAction>
        ) : (
          <SongCover size="medium" status={song.status} />
        )}
      </Td>
      <Td
        data-testid="title"
        sx={{ pl: 0 }}
        color={isSongLoaded || isSongPlaying ? 'P.80' : undefined}
      >
        <ListItemText
          primary={song.title}
          secondary={SongStatusLabel[song.status]}
          secondaryTextProps={{
            fontSize: 'xs',
            color: 'textSubdued',
          }}
        />
      </Td>
      <Td className="gap" />
      <Td>
        {contextHandler && <ContextMenuButton onClick={contextHandler} />}
      </Td>
    </Tr>
  );
};
